import type { InputKind } from '../engine/types';
import type { NamingSystem } from '../music/pitchNames';
import { Store } from './store';

export type TolerancePreset = 'beginner' | 'intermediate' | 'advanced';
/** Affichage de la scène de pratique : notes descendantes, partition, ou les deux. */
export type DisplayMode = 'falling' | 'sheet' | 'both';

export const TOLERANCE_MS: Record<TolerancePreset, number> = { beginner: 120, intermediate: 80, advanced: 50 };
export const WIDE_WINDOW_MS = 300;

export interface Settings {
  version: 1;
  inputKind: InputKind;
  midiDeviceId: string | null;
  micDeviceId: string | null;
  /** Compensation de la latence d'entrée du micro, en ms (soustraite à l'instant des attaques, qui sont déjà datées dans le flux audio). */
  micLatencyMs: number;
  tolerance: TolerancePreset;
  naming: NamingSystem;
  /** Clic audio du métronome (le métronome visuel est toujours actif). */
  audioClick: boolean;
  showNames: boolean;
  showFingers: boolean;
  /** Mode développeur : source de synthèse et outils d'essai. */
  developer: boolean;
  display: DisplayMode;
  /** Parcours « Configurer mon piano » : source validée, date et verdict de l'essai. */
  setupSource: InputKind | null;
  setupDoneAt: string | null;
  setupVerdict: 'ok' | 'uncertain' | null;
}

export const DEFAULT_SETTINGS: Settings = {
  version: 1,
  inputKind: 'mic',
  midiDeviceId: null,
  micDeviceId: null,
  micLatencyMs: 30,
  tolerance: 'beginner',
  naming: 'fr',
  audioClick: false,
  showNames: true,
  showFingers: true,
  developer: false,
  display: 'both',
  setupSource: null,
  setupDoneAt: null,
  setupVerdict: null,
};

export const settingsStore = new Store<Settings>('pianohome.settings.v1', DEFAULT_SETTINGS);
